// removed by extract-text-webpack-plugin
module.exports = {"black":"black__3y4_w","content":"content__c2W3_"};


//////////////////
// WEBPACK FOOTER
// ./src/App.scss
// module id = 383
// module chunks = 0